export default "__VITE_ASSET__BQT20kNQ__"